'use client'

import { useRouter } from 'next/navigation'

import { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

import { CallToActionBlock } from '@/blocks/CallToAction/Component'
import { useLegislativeContext } from '@/providers/LegislativeProvider'

export const AllBillsCTA = () => {
  const router = useRouter()
  const { selectedState, setSelectedState, setSelectedLegislativeTab } = useLegislativeContext()

  const handleStateChange = (value: string | undefined) => {
    if (!value) return

    // Update context state
    setSelectedLegislativeTab('state')
    setSelectedState(value)

    // Navigate to the state's bills page
    router.push(`/legislative-tracker/bills/${value.toLowerCase()}`)
  }

  return (
    <CallToActionBlock
      header="Contact your representatives"
      richText={
        {
          root: {
            type: 'paragraph',
            children: [
              {
                type: 'text',
                text: "Support MAHA's mission by taking action on the legislation that matters most to you. Find a bill above, then contact your state representative below to urge them to support MAHA's position.",
              },
            ],
          },
        } as unknown as DefaultTypedEditorState
      }
      blockType="cta"
      showStateSelect={true}
      stateSelectProps={{
        selectedState,
        handleStateChange,
      }}
    />
  )
}
